// TODO
//Попробовать переделать в setup
import { defineStore } from 'pinia'
import { useAuth } from '@websanova/vue-auth'
import Cookies from 'js-cookie'
import axios from 'axios'
import { getSubsStatus } from '@/api/endpoints/profile'
import { useRouter } from 'vue-router'
import AppConfig from '@/config'
import { redirectToAuth } from '@/utils/authRedirect'
import { clearGuestId, ensureGuestId } from '@/utils/guestId'
import { STORAGE_KEYS } from '@/constants/storageKeys'
import { useUsageStore } from '@/stores/usage'
import { useLoginStore } from '@/stores/login'
import { isOnboardingCompleted, type VerifyCodeResponse } from '@/api/endpoints/auth'
import { trackAuthSuccess } from '@/services/metrikaGoals'
import { computed } from 'vue'

// export const useAuthStore = defineStore('auth', {
// 	state: (): AuthState => ({
// 		auth: useAuth(),
// 		router: useRouter()
// 	}),
// 	getters: {
// 		isAuthenticated: (state) => {
// 			return state.auth.check()
// 		}
// 	},
// 	actions: {
// 		async logout() {
// 			const token = this.auth.token()
// 			this.auth.unremember()
// 			this.auth.logout({
// 				makeRequest: false,
// 				redirect: undefined
// 			})
// 			await axios.post(
// 				AppConfig.logoutUrl,
// 				{},
// 				{
// 					headers: {
// 						Authorization: `Bearer ${token}`
// 					},
// 					withCredentials: true
// 				}
// 			)
// 			window.location.replace(AppConfig.authRedirectUrl)
// 		},
// 		loginMock() {
// 			if (AppConfig.devSetting && !this.isAuthenticated) {
// 				this.auth.token(undefined, 'jZnBLnyV4XbcwxpqHo6NAqrST9LXWVfxF4s4kTJY673ddfff', false)
// 				this.auth.remember(JSON.stringify(this.auth.user()))
// 			}
// 		},
// 		async login() {
// 			const cookieName = AppConfig.tokenCookieName
// 			const cookie = Cookies.get(cookieName)
// 			let token: string
// 			if (cookie) {
// 				token = decodeURI(cookie)
// 				Cookies.remove(cookieName)

// 				await this.auth.token(undefined, token, false)
// 				await this.auth.remember(JSON.stringify(this.auth.user()))
// 			}
// 		},
// 		async loginT() {
// 			const cookieName = AppConfig.tokenCookieName
// 			const cookie = Cookies.get(cookieName)
// 			let token: string

// 			if (cookie) {
// 				token = decodeURI(cookie)
// 				Cookies.remove(cookieName)

// 				await this.auth.token(undefined, token, false)
// 				await this.auth.remember(JSON.stringify(this.auth.user()))
// 			}
// 		},
// 		async pollSubStatus(delay = 4000, maxAttempts = 10): Promise<boolean> {
// 			for (let attempt = 1; attempt <= maxAttempts; attempt++) {
// 				try {
// 					const answer = await getSubsStatus()

// 					if (answer.data.is_subscribed) {
// 						const currentRoute = this.router.currentRoute
// 						this.router.push({
// 							path: '/',
// 							query: currentRoute.query
// 						})
// 						return true
// 					}

// 					if (attempt < maxAttempts) {
// 						await new Promise((resolve) => setTimeout(resolve, delay))
// 					}
// 				} catch (error) {
// 					console.error(`Ошибка получения статуса подписки (попытка ${attempt}):`, error)

// 					// Редирект при любой ошибке, включая последнюю попытку
// 					window.location.replace(AppConfig.authRedirectUrl)
// 					return false // Прерываем выполнение после редиректа
// 				}
// 			}

// 			console.warn(`Подписка не активирована после ${maxAttempts} попыток`)
// 			// Редирект после исчерпания всех попыток без успешной подписки
// 			window.location.replace(AppConfig.authRedirectUrl)
// 			return false
// 		}
// 	}
// })

/**
 * Ключи хранилища, принадлежащие сессии конкретного пользователя. Логаут уходит полной
 * навигацией, но перезагрузка их не уносит: localStorage переживает её вообще, а
 * sessionStorage — в пределах вкладки. Не снимешь здесь — и billing.restore() начнёт
 * поллить чужой заказ, generation поднимет задачи по чужим тредам, а на шаге входа
 * всплывёт e-mail ушедшего пользователя.
 */
function clearUserScopedStorage(): void {
	localStorage.removeItem(STORAGE_KEYS.BILLING_PENDING_ORDER)
	sessionStorage.removeItem(STORAGE_KEYS.GENERATION_TASKS)
	sessionStorage.removeItem(STORAGE_KEYS.LOGIN_STEP)
}

export const useAuthStore = defineStore('auth', () => {
	const auth = useAuth()
	const router = useRouter()

	const isAuthenticated = computed(() => auth.check())

	async function logout() {
		const token = auth.token()
		auth.unremember()
		auth.logout({ makeRequest: false, redirect: undefined })
		// В internal-режиме после логаута пользователь остаётся на сайте и снова становится гостем.
		ensureGuestId()
		clearUserScopedStorage()
		// Гостевой счётчик нового гостя начинается с нуля. Дубль снятия cookie при входе,
		// зато инвариант не зависит от того, каким путём этот вход прошёл.
		useUsageStore().resetGuestUsed()
		try {
			await axios.post(
				AppConfig.logoutUrl,
				{},
				{ headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
			)
		} catch (error) {
			// Локально мы уже вышли, поэтому сетевой сбой не имеет права оставить человека
			// на экране кабинета без токена и без навигации.
			console.warn('logout на сервере не прошёл', error)
		}
		// Полная навигация вместо router.push: сторы (usage, profile, thread, topics) должны
		// перезапроситься уже под гостем — так же, как это делает вход в LoginCodeView.
		// Иначе UsageBar до перезагрузки показывает остаток ушедшего пользователя.
		if (!redirectToAuth()) window.location.replace('/')
	}

	async function loginMock() {
		if (!AppConfig.devSetting || isAuthenticated.value) return
		const devToken = import.meta.env.VITE_DEV_AUTH_TOKEN
		if (!devToken) return
		auth.token(undefined, devToken, false)
		auth.remember(JSON.stringify(auth.user()))
		clearGuestId()
	}

	/**
	 * Единственная точка сохранения сессии: и внешний auth-сервис (токен в cookie),
	 * и внутренний вход по e-mail + OTP приходят сюда.
	 */
	async function loginWithToken(token: string) {
		await auth.token(undefined, token, false)
		await auth.remember(JSON.stringify(auth.user()))
		clearGuestId()
		// Гостевой счётчик бесплатных запросов после входа не действует.
		useUsageStore().resetGuestUsed()
	}

	/** Завершение входа — общее для кода на e-mail и OAuth-callback. */
	async function finishLogin(result: VerifyCodeResponse) {
		await loginWithToken(result.token)
		trackAuthSuccess(result.is_new === true)

		// Цель берём из ответа — он уже принёс user, отдельный GET /user не нужен.
		// is_new — страховка: у только что созданного аккаунта онбординг точно не пройден,
		// даже если флаг придёт пустым. undefined (флага нет) на онбординг не ведёт.
		const target = isOnboardingCompleted(result.user) === false || result.is_new ? '/onboarding' : '/'
		useLoginStore().reset()
		// Полная навигация вместо router.replace: сторы (topics, usage, profile) должны
		// перезапроситься уже под авторизованным пользователем — так же, как при возврате
		// с внешнего auth-сервиса, где приложение всегда стартует заново.
		window.location.replace(target)
	}

	async function login() {
		const cookie = Cookies.get(AppConfig.tokenCookieName)
		if (!cookie) return
		const token = decodeURI(cookie)
		Cookies.remove(AppConfig.tokenCookieName)
		await loginWithToken(token)
	}

	async function pollSubStatus(delay: number = 4000, maxAttempts: number = 10): Promise<boolean> {
		for (let attempt = 1; attempt <= maxAttempts; attempt++) {
			try {
				const answer = await getSubsStatus()
				if (answer.data.is_subscribed) {
					router.push({ path: '/', query: router.currentRoute.value.query })
					return true
				}
				if (attempt < maxAttempts) {
					await new Promise((r) => setTimeout(r, delay))
				}
			} catch (error) {
				console.error(`Ошибка статуса подписки (попытка ${attempt}):`, error)
				if (!redirectToAuth()) router.push('/')
				return false
			}
		}
		console.warn(`Подписка не активирована после ${maxAttempts} попыток`)
		if (!redirectToAuth()) router.push('/')
		return false
	}

	return {
		isAuthenticated,
		logout,
		loginMock,
		login,
		loginWithToken,
		finishLogin,
		pollSubStatus
	}
})
